export const phoneDisplayValueCasting = (value: string, isMasked?: boolean) =>
  value.replace(
    /(.{2})(\d{3})(\d{3})(\d{2})(\d{2})/g,
    isMasked ? '$1 ($2) ***-**-$5' : '$1 ($2) $3-$4-$5'
  );
